module.exports = __webpack_public_path__ + "img/checkbox-full.e5941b80.svg";